<div class="d-flex align-items-start">
    <sb-user-avatar
        class="user-avatar user-avatar-btn me-2"
        [user]="entity.user"
        [size]="'extra-small'"
        [isNeedTooltip]="false"
        [withRoleTooltip]="true">
    </sb-user-avatar>
    <div class="text-break">
        <a class="user-name" (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: entity.user })">
            {{ entity.user.name || entity.user.email }}
        </a>
        @for (item of logStringArray; track item) {
            @switch (item.entityType) {
                @case (highlightEntityTypeEnum.text) {
                    {{ item.text }}
                }

                @case (highlightEntityTypeEnum.user) {
                    <a
                        class="user-name"
                        (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: item.entity })">
                        {{ item.entityName }}
                    </a>
                }

                @case (highlightEntityTypeEnum.group) {
                    <a
                        class="group-name"
                        (click)="rightPanelService.open(rightPanelTypeEnum.groupInfo, { groupId: item.entity.id })">
                        {{ item.entityName }}
                    </a>
                }

                @case (highlightEntityTypeEnum.ticket) {
                    <a
                        [routerLink]="['/', commonDataService.communityName, 'tickets']"
                        [queryParams]="item.queryParams">
                        #{{ item.forwardedToTicketId }}
                    </a>
                }

                @case (highlightEntityTypeEnum.reply) {
                    {{ 'reply' | translate }}
                    @if (item.entity) {
                        <app-reply-quote [reply]="item.entity"></app-reply-quote>
                    }
                }

                @case (highlightEntityTypeEnum.url) {
                    <a [href]="item.entityName" target="_blank">{{ item.entityName }}</a>
                }

                @default {
                    <a
                        [routerLink]="['/', commonDataService.communityName, 'tickets']"
                        [queryParams]="item.queryParams"
                        [innerHTML]="item.entityName | replaceEmojis: false : true">
                    </a>
                }
            }
        }
    </div>
</div>
